var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 12.5781H11.2109V15.0781H9.96094V12.5781ZM13.0859 11.3281H14.3359V15.0781H13.0859V11.3281ZM6.83594 8.82812H8.08594V15.0781H6.83594V8.82812Z",
    fill: "#9C4900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2109 3.20312H14.3359V2.57812C14.3359 2.2466 14.2042 1.92866 13.9698 1.69424C13.7354 1.45982 13.4175 1.32813 13.0859 1.32812H8.08594C7.75442 1.32813 7.43647 1.45982 7.20205 1.69424C6.96763 1.92866 6.83594 2.2466 6.83594 2.57812V3.20312H4.96094C4.62942 3.20312 4.31147 3.33482 4.07705 3.56924C3.84263 3.80366 3.71094 4.1216 3.71094 4.45312V17.5781C3.71094 17.9096 3.84263 18.2276 4.07705 18.462C4.31147 18.6964 4.62942 18.8281 4.96094 18.8281H16.2109C16.5425 18.8281 16.8604 18.6964 17.0948 18.462C17.3292 18.2276 17.4609 17.9096 17.4609 17.5781V4.45312C17.4609 4.1216 17.3292 3.80366 17.0948 3.56924C16.8604 3.33482 16.5425 3.20312 16.2109 3.20312ZM8.08594 2.57812H13.0859V5.07812H8.08594V2.57812ZM16.2109 17.5781H4.96094V4.45312H6.83594V6.32812H14.3359V4.45312H16.2109V17.5781Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsActive);
export default __webpack_public_path__ + "static/media/reports_active.be2103481efa701a8221f254a2781133.svg";
export { ForwardRef as ReactComponent };